import styled, { keyframes } from 'styled-components';
import { ReactComponent as Loading } from "../../../../mainApp/images/loading.svg"; // Assuming this is your light loading SVG
import { ReactComponent as LoadingForDark } from "../../../../mainApp/images/loadingForDark.svg"; // Assuming this is your dark loading SVG

const slideInOut = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
`;
//Loading równa się animation for light mode
export const StyledLoading = styled(({ isLight, ...props }) =>
  isLight ? <LoadingForDark {...props} /> : <LoadingForDark {...props} />
)`
  display: flex;
  align-items: center;
  height: 121px;
  transform: rotate(360deg);
  animation: spin;
  animation-duration: 1.25s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes spin {
    from {
      transform: unset;
    }
    to {
      transform: translateX(360deg);
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    height: 91px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 66px;
  margin-top: 406px;
  min-width: 280px;
`;

export const Message = styled.p`
  font-weight: ${({ theme }) => theme.fontSize.regular};
  font-size: 20px;
  letter-spacing: 0.05em;
  color: #252525;
  line-height: 130%;
  padding-bottom: 20px;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    font-size: 16px;
  }
`;

export const Div = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: ${({ isHighZIndex }) => (isHighZIndex ? 999999 : 1)};
  transition: opacity 1s ease-in-out; 
  background-color: ${({ theme }) => theme.color.spotifyBlack};
  background-repeat: no-repeat;
  background-size: cover;
`;